<template lang="pug">
div
  section.mb-6(v-for="categoria in categorias", :key="categoria.id")
    h2.title.grey.lighten-3.pa-2.mb-3
      faq-status.mr-2(:status="categoria.status")
      | {{ categoria.titulo }}
    p.text-center.grey--text.font-italic(v-if="!categoria.secoes.length") Nenhuma seção cadastrada
    v-row(v-else)
      v-col(
        v-for="secao in categoria.secoes",
        :key="secao.id",
        cols="12",
        md="6"
      )
        v-card.faq-card(outlined)
          v-card-title.faq-card-title.py-0
            faq-status.mr-2(:status="secao.status")
            | {{ secao.titulo }}
          v-list.faq-list
            template(v-for="(artigo, index) in artigosOrdenados(secao)")
              v-divider(v-if="index > 0", :key="'divider-' + artigo.id")
              v-list-item(
                :key="artigo.id",
                link,
                @click="$emit('visualizar', artigo)"
              )
                v-list-item-icon
                  faq-status(:status="artigo.status")
                v-list-item-content
                  v-list-item-title {{ artigo.titulo }}
            v-list-item.faq-empty-articles(v-if="!secao.artigos.length")
              v-list-item-content
                v-list-item-title.text-center.grey--text.font-italic Nenhum artigo cadastrado
</template>

<script>
import ordenarArtigosDaSecao from "@/utils/faq";
import FaqStatus from "./FaqStatus.vue";

export default {
  name: "FaqInicio",
  components: { FaqStatus },
  props: {
    categorias: { type: Array, required: true },
  },
  methods: {
    artigosOrdenados(secao) {
      return ordenarArtigosDaSecao(secao);
    },
  },
};
</script>
